<app-article [article]="options"></app-article>
